import React from "react";
import "../../styles/Footer.css";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-links">
        <Link to="/about">Shortfy FAQ</Link>
        <Link to="/privacy">Privacy Notice</Link>
      </div>
      <div className="footer-copy">© CGI Inc. All rights reserved.</div>
    </footer>
  );
};

export default Footer;
